import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetById, GetUsersByBatchId } from '../../service/BatchService';
import { GetUserById } from '../../service/UserService';
import { GetByUserAndBatch, GetByBatchId } from '../../service/PaymentService';
import { Add, createRazorpayOrder } from '../../service/PaymentService';

export default function BatchStudentPayment() {
  const {
    isLoading,
    setIsLoading,
    isAppError,
    setAppError,
    appErrorMessage,
    setAppErrorMessage,
    appErrorTitle,
    setAppErrorTitle,
    appErrorMode,
    setAppErrorMode,
    appUser,
  } = useGlobalContext();

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const itemsPerPage = 10;
  const { id } = useParams();

  const userId = appUser._id; // Get the user ID from the appUser context

  const [payments, setPayments] = useState([]);
  const [users, setUsers] = useState([]);

  const [batchDetails, setBatchDetails] = useState({});
  const [userDetails, setUserDetails] = useState({});

  const [amountPaid, setAmountPaid] = useState(0);
  const [balance, setBalance] = useState(0);
  const [total, setTotal] = useState(0);

  //student count 
  const [studentCount, setStudentCount] = useState(0);
  const [totalToBeReceived, setTotalToBeReceived] = useState(0);

  const [currentPageStudent, setCurrentPageStudent] = useState(1);
  const [totalPagesStudent, setTotalPagesStudent] = useState(1);
  const [totalItemsStudent, setTotalItemsStudent] = useState(0);
  const itemsPerPageStudent = 10;

  //payment
  const [amount, setAmount] = useState('');
  const [paymodeId, setPaymodeId] = useState('688dc76d65899c41b825cdbd');
  const [paymentDateTime, setPaymentDateTime] = useState(() => new Date().toISOString());
  const [reason, setReason] = useState('RaZorpay Payment');

  const fetchBatchDetails = async () => {
    try {
      setIsLoading(true);
      const response = await GetById(id);
      if (response?.batch) {
        setBatchDetails(response.batch);
      } else {
        setBatchDetails({});
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to fetch batch details");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchUserDetails = async () => {
    try {
      setIsLoading(true);
      const response = await GetUserById(userId);
      if (response?.user) {
        setUserDetails(response.user);

      } else {
        setUserDetails({});
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to fetch batch details");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchBatchStudentList = async () => {
    try {
      let totalPaid = 0;
      setIsLoading(true);
      const response = await GetUsersByBatchId(id, 1, 9999);
      const students = response.users || [];

      for (const student of students) {
        const paymentRes = await GetByUserAndBatch(student._id, id, 1, 9999);
        totalPaid += paymentRes.totalPaidAmount || 0;
      }

      setAmountPaid(totalPaid);
      const totalToBeReceived = parseFloat(batchDetails.fee || 0);
      setTotal(totalToBeReceived);
      setBalance(totalToBeReceived - totalPaid);
      setStudentCount(response.totalItems);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  //fetch get by batch id
  const fetchBatchPayments = async (page = 1) => {
    try {
      setIsLoading(true);
      var response = await GetByBatchId(id, page, itemsPerPage);
      setPayments(response.payments);
      setCurrentPage(response.currentPage);
      setTotalPages(response.totalPages);
      setTotalItems(response.totalItems);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchBatchStudentListPayment = async (page = 1) => {
    try {
      setIsLoading(true);
      const response = await GetUsersByBatchId(id, page, itemsPerPageStudent);
      setUsers(response.users);
      setCurrentPageStudent(response.currentPage);
      setTotalPagesStudent(response.totalPages);
      setTotalItemsStudent(response.totalItems);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  const savePayment = async (event) => {
    event.preventDefault();

    const enteredAmount = Number(amount);
    if (!enteredAmount || isNaN(enteredAmount) || enteredAmount <= 0) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Payment amount must be greater than 0.");
      setAppErrorMode("error");
      return;
    }

    if (enteredAmount > balance) {
      setAppError(true);
      setAppErrorTitle("Warning");
      setAppErrorMessage("Entered amount exceeds the pending fee balance.");
      setAppErrorMode("error");
      return;
    }

    setIsLoading(true);

    try {
      const orderData = await createRazorpayOrder(enteredAmount);
      console.log("Order Data:", orderData);
      if (!orderData?.orderId) throw new Error('Order creation failed');

      const options = {
        key: config.razorpayKeyId,
        amount: orderData.amount,
        currency: orderData.currency,
        name: "Payful Pencil",
        description: "Batch Fee Payment",
        order_id: orderData.orderId,
        handler: async function (response) {
          try {
            const razorpay_payment_id = response.razorpay_payment_id;           
            response = await Add(paymodeId, userId, id, enteredAmount, paymentDateTime, razorpay_payment_id, reason);
            if (response.status === 200) {
              setAppError(true);
              setAppErrorTitle("Action Response");
              setAppErrorMessage(response.message || "Payment Successfully Added");
              setAppErrorMode("success");
              if (userId && id) {
                window.location.href = `/batch/summary/manage/${id}`;
              } else {
                console.error("Invalid userId or batch id");
              }
            } else {
              setAppError(true);
              setAppErrorTitle("Error");
              setAppErrorMessage(response.message || "Action failed. Please try again.");
              setAppErrorMode("error");
            }
          } catch (error) {
            setAppError(true);
            setAppErrorTitle("Error");
            setAppErrorMessage("Something went wrong. Please try again.");
            setAppErrorMode("error");
          } finally {
            setIsLoading(false);
          }
        },
        prefill: {
          name: appUser?.username || "",
          email: appUser?.email || "",
          contact: appUser?.mobile || "",
        },
        notes: {
          batch: batchDetails?.name || "",
          name: appUser?.username || "",
          email: appUser?.email || "",
          mobile: appUser?.mobile || "",
        },
        theme: {
          color: "#3399cc"
        }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (error) {
      console.error(error);
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Payment initiation failed.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    fetchBatchDetails();
    fetchUserDetails();
    fetchBatchStudentList();
  }, []);

  React.useEffect(() => {
    fetchBatchPayments(currentPage);
  }, []);

  React.useEffect(() => {
    fetchBatchStudentListPayment(currentPageStudent);
  }, []);

  useEffect(() => {
    if (studentCount && batchDetails?.fee) {
      const fee = Number(batchDetails.fee);
      if (!isNaN(fee)) {
        setTotalToBeReceived(studentCount * fee);
      }
    }
  }, [studentCount, batchDetails]);

  useEffect(() => {
    if (batchDetails && batchDetails.fee) {
      fetchBatchStudentList(); // now fee is available
    }
  }, [batchDetails]);


  return (
    <>
      <Helmet>
        <title>Fee Payment | {config.appName}</title>
      </Helmet>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>My Fee Payment</h1>
            <span>
              <Link to="/"> Dashboard </Link> / <Link to={`/batch/summary/manage/${id}`}> Fee Summary </Link>
              / My Fee Payment
            </span>
          </div>

          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <div className='row'>
                  <div className='col-lg-12 col-md-12 col-sm-12'>
                    <div className='batch-details'>
                      <div className='row'>
                        <div className='col-lg-3 col-md-3 col-sm-12'>
                          Category : <strong>{batchDetails?.courseId?.categoryId?.name || '-'}</strong>
                        </div>
                        <div className='col-lg-3 col-md-3 col-sm-12'>
                          Sub Category : <strong> {batchDetails?.courseId?.subCategoryIds
                            ?.map(sub => sub.name)
                            .join(", ")}</strong>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12'>
                          Course : <strong>{batchDetails?.courseId?.name || '-'}</strong>
                        </div>
                      </div>
                    </div>
                    <br></br>
                    <div className='batch-details'>
                      <div className='row'>
                        <div className='col-lg-3 col-md-3 col-sm-12'>
                          Batch Code : <strong>{batchDetails?.code || '-'}</strong>
                        </div>
                        <div className='col-lg-3 col-md-3 col-sm-12'>
                          Start Date : <strong>
                            {batchDetails?.startDate
                              ? (() => {
                                const date = new Date(batchDetails.startDate);
                                const day = String(date.getDate()).padStart(2, '0');
                                const month = String(date.getMonth() + 1).padStart(2, '0');
                                const year = date.getFullYear();
                                return `${day}-${month}-${year}`;
                              })()
                              : '-'}
                          </strong>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12'>
                          Batch Name : <strong>{batchDetails?.name || '-'}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br></br>
                <div className='row'>
                  <div className='mb-4'>
                    <div className='row g-3'>
                      <div className='col-md-4'>
                        <div className='card shadow-sm border-start border-4 border-primary'>
                          <div className='card-body d-flex justify-content-between align-items-center'>
                            <div>
                              <h6 className='text-muted mb-1'>Total Fee</h6>
                              <h5 className='text-primary mb-0'>₹ {total}</h5>
                            </div>
                            <div className='icon bg-primary text-white rounded-circle d-flex justify-content-center align-items-center' style={{ width: '40px', height: '40px' }}>
                              <FontAwesomeIcon icon="fa-solid fa-file-invoice-dollar" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-4'>
                        <div className='card shadow-sm border-start border-4 border-success'>
                          <div className='card-body d-flex justify-content-between align-items-center'>
                            <div>
                              <h6 className='text-muted mb-1'>Total Paid</h6>
                              <h5 className='text-success mb-0'>₹ {amountPaid}</h5>
                            </div>
                            <div className='icon bg-success text-white rounded-circle d-flex justify-content-center align-items-center' style={{ width: '40px', height: '40px' }}>
                              <FontAwesomeIcon icon="fa-solid fa-wallet" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-4'>
                        <div className='card shadow-sm border-start border-4 border-danger'>
                          <div className='card-body d-flex justify-content-between align-items-center'>
                            <div>
                              <h6 className='text-muted mb-1'>Balance Amount</h6>
                              <h5 className='text-danger mb-0'>₹ {balance}</h5>
                            </div>
                            <div className='icon bg-danger text-white rounded-circle d-flex justify-content-center align-items-center' style={{ width: '40px', height: '40px' }}>
                              <FontAwesomeIcon icon="fa-solid fa-coins" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-lg-6 col-md-6 col-xs-12'>
                    <h5><b> <FontAwesomeIcon icon="fa-solid fa-plus-circle" /> Fee Payment </b></h5>
                    <div className='batch-details'>
                      <form onSubmit={savePayment} encType='multipart/form-data'>
                        <div className='row'>
                          <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                            <div className="mb-3">
                              <label className="form-label">Enter Amount</label>
                              <input className='form-control' type='text' value={amount} onChange={(e) => setAmount(e.target.value)} />
                            </div>
                          </div>
                          <div className='clearfix'></div>
                          <div className='col-12 text-end'>
                            <div className="mb-3">
                              <button type='submit' className='btn btn-success-app btn-md'> <i className="ri-check-fill"></i> Submit </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
}